const ICON_BASE: React.CSSProperties = {
  width: "1rem",
  height: "1rem",
  display: "block",
  fill: "currentColor",
};

export function IconCard(props: { style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" style={{ ...ICON_BASE, ...props.style }} aria-hidden>
      <path d="M3 5h18a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2zm0 4v2h18V9H3zm0 4v4h18v-4H3zm2 2h4v1H5v-1z" />
    </svg>
  );
}

export function IconQuestion(props: { style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" style={{ ...ICON_BASE, ...props.style }} aria-hidden>
      <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm.07 16h-.14a1.06 1.06 0 0 1-1.07-1.06v-.05a1.06 1.06 0 0 1 1.07-1.06h.14A1.06 1.06 0 0 1 13.14 17v.05A1.06 1.06 0 0 1 12.07 18zm2-7.06c-.66.4-1.07.66-1.07 1.31v.25a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-.49a2.66 2.66 0 0 1 1.46-2.4c.69-.41 1.04-.78 1.04-1.36 0-.78-.66-1.25-1.5-1.25a1.65 1.65 0 0 0-1.49.86.5.5 0 0 1-.71.18l-.83-.5a.5.5 0 0 1-.16-.7A3.7 3.7 0 0 1 12 6c2.06 0 3.5 1.3 3.5 3.06 0 1.31-.7 1.94-1.43 2.38z" />
    </svg>
  );
}

export function IconDollar(props: { style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" style={{ ...ICON_BASE, ...props.style }} aria-hidden>
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-1.26a3.43 3.43 0 0 1-2.74-2.62l1.83-.74a1.8 1.8 0 0 0 1.78 1.4c.86 0 1.79-.45 1.79-1.36 0-.85-.71-1.16-2.31-1.76-1.11-.41-2.83-1.06-2.83-2.95a3 3 0 0 1 2.48-2.78V5h2v1.93a3.05 3.05 0 0 1 2.45 2.06l-1.79.77a1.62 1.62 0 0 0-1.6-1.16c-.91 0-1.54.51-1.54 1.22 0 .75.69 1.06 2.1 1.59 1.83.65 3.04 1.34 3.04 3.12A3.13 3.13 0 0 1 13 17.68z" />
    </svg>
  );
}

export function IconSearch(props: { style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" style={{ ...ICON_BASE, ...props.style }} aria-hidden>
      <path d="M15.5 14h-.79l-.28-.27a6.5 6.5 0 0 0 1.48-5.34A6.5 6.5 0 1 0 14.73 14h.79l5 5 1.49-1.49-5-5zm-6 0A4.5 4.5 0 1 1 14 9.5 4.49 4.49 0 0 1 9.5 14z" />
    </svg>
  );
}

export function IconTicket(props: { style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" style={{ ...ICON_BASE, ...props.style }} aria-hidden>
      <path d="M20 4H4a2 2 0 0 0-2 2v3a2 2 0 0 1 0 4v3a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3a2 2 0 0 1 0-4V6a2 2 0 0 0-2-2zm-5 12h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V6h2v2z" />
    </svg>
  );
}

export function IconLifebuoy(props: { style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" style={{ ...ICON_BASE, ...props.style }} aria-hidden>
      <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm6.32 5.1-2.7 2.7a4 4 0 0 0-1.42-1.42l2.7-2.7a8.05 8.05 0 0 1 1.42 1.42zM12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6zM9.1 5.68l2.7 2.7a4 4 0 0 0-1.42 1.42l-2.7-2.7A8.05 8.05 0 0 1 9.1 5.68zM5.68 9.1l2.7 2.7a4 4 0 0 0 0 2l-2.7 2.7a8 8 0 0 1 0-7.4zm1.4 8.82 2.7-2.7c.42.32.9.57 1.42.72v3.82a8 8 0 0 1-4.12-1.84zm6.12 1.84v-3.82c.52-.15 1-.4 1.42-.72l2.7 2.7a8 8 0 0 1-4.12 1.84zm5.12-3.26-2.7-2.7a4 4 0 0 0 0-2l2.7-2.7a8 8 0 0 1 0 7.4z" />
    </svg>
  );
}

export function IconPhone(props: { style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" style={{ ...ICON_BASE, ...props.style }} aria-hidden>
      <path d="M6.62 10.79a15.15 15.15 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.02-.24c1.12.37 2.33.57 3.57.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.24.2 2.45.57 3.57a1 1 0 0 1-.24 1.02l-2.21 2.2z" />
    </svg>
  );
}

export function IconLink(props: { style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" style={{ ...ICON_BASE, ...props.style }} aria-hidden>
      <path d="M3.9 12a3.1 3.1 0 0 1 3.1-3.1h4V7H7a5 5 0 0 0 0 10h4v-1.9H7A3.1 3.1 0 0 1 3.9 12zM8 13h8v-2H8v2zm9-6h-4v1.9h4a3.1 3.1 0 0 1 0 6.2h-4V17h4a5 5 0 0 0 0-10z" />
    </svg>
  );
}

export function IconCopy(props: { style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" style={{ ...ICON_BASE, ...props.style }} aria-hidden>
      <path d="M16 1H4a2 2 0 0 0-2 2v14h2V3h12V1zm3 4H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm0 16H8V7h11v14z" />
    </svg>
  );
}

export function IconPause(props: { style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" style={{ ...ICON_BASE, ...props.style }} aria-hidden>
      <path d="M6 4h4v16H6zM14 4h4v16h-4z" />
    </svg>
  );
}

export function IconRotateLeft(props: { style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" style={{ ...ICON_BASE, ...props.style }} aria-hidden>
      <path d="M7.11 8.53 5.7 7.11A8 8 0 1 0 19.84 13H17.7A6 6 0 1 1 7.11 8.53zM12 4V0L7 5l5 5V6a5.99 5.99 0 0 1 4.83 9.5l1.42 1.42A8 8 0 0 0 12 4z" />
    </svg>
  );
}

export function IconRotateRight(props: { style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" style={{ ...ICON_BASE, ...props.style }} aria-hidden>
      <path d="M16.89 8.53 18.3 7.11A8 8 0 1 1 4.16 13H6.3A6 6 0 1 0 16.89 8.53zM12 4V0l5 5-5 5V6a5.99 5.99 0 0 0-4.83 9.5l-1.42 1.42A8 8 0 0 1 12 4z" />
    </svg>
  );
}

export function IconPlay(props: { style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" style={{ ...ICON_BASE, ...props.style }} aria-hidden>
      <path d="M8 5v14l11-7z" />
    </svg>
  );
}

export function IconRefresh(props: { style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" style={{ ...ICON_BASE, ...props.style }} aria-hidden>
      <path d="M17.65 6.35A8 8 0 1 0 19.73 14h-2.08a6 6 0 1 1-1.55-6.36L13 11h7V4l-2.35 2.35z" />
    </svg>
  );
}

export function IconCheck(props: { style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" style={{ ...ICON_BASE, ...props.style }} aria-hidden>
      <path d="M9 16.17 4.83 12l-1.42 1.41L9 19l12-12-1.41-1.41z" />
    </svg>
  );
}

export function IconFolder(props: { style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" style={{ ...ICON_BASE, ...props.style }} aria-hidden>
      <path d="M10 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-8l-2-2z" />
    </svg>
  );
}

export function IconFile(props: { style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" style={{ ...ICON_BASE, ...props.style }} aria-hidden>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 7V3.5L18.5 9H13z" />
    </svg>
  );
}

export function IconImage(props: { style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" style={{ ...ICON_BASE, ...props.style }} aria-hidden>
      <path d="M21 19V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
    </svg>
  );
}

export function IconPdf(props: { style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" style={{ ...ICON_BASE, ...props.style }} aria-hidden>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-3 13H9.5v-2H11v2zm0-3H9.5v-1.5H11V12zm-1.5-3H8V7h1.5v2zm5 6h-2v-2h2v2zm0-3h-2v-1.5h2V12zm0-3h-2V7h2v2zM13 9V3.5L18.5 9H13z" />
    </svg>
  );
}

export function IconClose(props: { style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" style={{ ...ICON_BASE, ...props.style }} aria-hidden>
      <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
    </svg>
  );
}

export function IconDownload(props: { style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" style={{ ...ICON_BASE, ...props.style }} aria-hidden>
      <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
    </svg>
  );
}

export function IconBuilding(props: { style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" style={{ ...ICON_BASE, ...props.style }} aria-hidden>
      <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" />
    </svg>
  );
}

export function IconClipboardList(props: { style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" style={{ ...ICON_BASE, ...props.style }} aria-hidden>
      <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14H7v-2h3v2zm0-4H7v-2h3v2zm0-4H7V7h3v2zm7 8h-5v-2h5v2zm0-4h-5v-2h5v2zm0-4h-5V7h5v2z" />
    </svg>
  );
}

export function IconHistory(props: { style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" style={{ ...ICON_BASE, ...props.style }} aria-hidden>
      <path d="M13 3a9 9 0 0 0-9 9H1l3.89 3.89.07.14L9 12H6a7 7 0 1 1 7 7c-1.93 0-3.68-.79-4.95-2.05l-1.42 1.42A8.97 8.97 0 0 0 13 21a9 9 0 0 0 0-18zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z" />
    </svg>
  );
}

export function IconRenew(props: { style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" style={{ ...ICON_BASE, ...props.style }} aria-hidden>
      <path d="M12 6V3L8 7l4 4V8c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0 0 20 14c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 9.74A7.93 7.93 0 0 0 4 14c0 4.42 3.58 8 8 8v3l4-4-4-4v3z" />
    </svg>
  );
}

export function IconHeartPulse(props: { style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" style={{ ...ICON_BASE, ...props.style }} aria-hidden>
      <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 .59-.08 1.16-.22 1.71h-2.62l-1.69-2.54-3 4.5L11 9.5 9 13H6.5a16.66 16.66 0 0 0 4.05 4.03L12 18.35z" />
    </svg>
  );
}

export function IconWarning(props: { style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" style={{ ...ICON_BASE, ...props.style }} aria-hidden>
      <path d="M12 2 1 21h22L12 2zm0 5.84L19.53 19H4.47L12 7.84zM11 10h2v4h-2zm0 6h2v2h-2z" />
    </svg>
  );
}

export function FlagES(props: { style?: React.CSSProperties }) {
  return (
    <svg
      viewBox="0 0 24 16"
      style={{
        width: "1.4rem",
        height: "0.95rem",
        borderRadius: "2px",
        display: "block",
        ...props.style,
      }}
      aria-hidden
    >
      <rect width="24" height="16" fill="#aa151b" />
      <rect width="24" height="8" y="4" fill="#f1bf00" />
    </svg>
  );
}

export function FlagIT(props: { style?: React.CSSProperties }) {
  return (
    <svg
      viewBox="0 0 24 16"
      style={{
        width: "1.4rem",
        height: "0.95rem",
        borderRadius: "2px",
        display: "block",
        ...props.style,
      }}
      aria-hidden
    >
      <rect width="8" height="16" x="0" fill="#009246" />
      <rect width="8" height="16" x="8" fill="#fff" />
      <rect width="8" height="16" x="16" fill="#ce2b37" />
    </svg>
  );
}

export function FlagFR(props: { style?: React.CSSProperties }) {
  return (
    <svg
      viewBox="0 0 24 16"
      style={{
        width: "1.4rem",
        height: "0.95rem",
        borderRadius: "2px",
        display: "block",
        ...props.style,
      }}
      aria-hidden
    >
      <rect width="8" height="16" x="0" fill="#0055a4" />
      <rect width="8" height="16" x="8" fill="#fff" />
      <rect width="8" height="16" x="16" fill="#ef4135" />
    </svg>
  );
}

export function IconWhatsApp(props: { style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" style={{ ...ICON_BASE, ...props.style }} aria-hidden>
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
  );
}

export function IconPin(props: { style?: React.CSSProperties }) {
  return (
    <svg viewBox="0 0 24 24" style={{ ...ICON_BASE, ...props.style }} aria-hidden>
      <path d="M16 3a1 1 0 0 1 1 1v.09c0 .68.28 1.33.77 1.8l1.34 1.28a1 1 0 0 1 .03 1.42l-4.55 4.72c-.2.2-.32.47-.35.75l-.3 2.61a1 1 0 0 1-1.7.6l-2.87-2.87-4.66 4.66a1 1 0 0 1-1.41-1.41l4.66-4.66-2.87-2.87a1 1 0 0 1 .6-1.7l2.61-.3c.28-.03.55-.15.75-.35l4.72-4.55A1 1 0 0 1 15.19 3H16z" />
    </svg>
  );
}
